<template>
  <div>
    <el-row class="vg_mb_8">
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_ctn_prsm'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>纸箱平方单价:</span>
            </el-col>
            <el-col :md="12">
              <el-input
                v-model="qutaForm.quta_ctn_prsm"
                size="small"
                @blur="qutaForm.quta_ctn_prsm = helper.calcPrice(qutaForm.quta_ctn_prsm, 4, 10000)"
                @change="cartonPriceChange(0)"
                @input="qutaForm.quta_ctn_prsm = helper.keepEngNum4(qutaForm.quta_ctn_prsm)"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.carton_price'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span
                >纸箱金额:
                <el-popover
                  content="纸箱金额=(长+宽+0.08) *（宽+高+0.04) * 纸箱单价 / 装箱数"
                  placement="top-start"
                  trigger="hover"
                  width="200"
                >
                  <i slot="reference" class="el-icon-warning-outline"></i> </el-popover
              ></span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.carton_price" disabled size="small"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_emcd_pnum'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>电绣贴数:</span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.quta_emcd_pnum" size="small" @change="emcdTotalPriceChnage(0)"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_emcd_hnum'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>电绣针数:</span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.quta_emcd_hnum" size="small" @change="emcdTotalPriceChnage(0)"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="vg_mb_8">
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_bag_prkg'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>塑料袋公斤单价:</span>
            </el-col>
            <el-col :md="12">
              <el-input
                v-model="qutaForm.quta_bag_prkg"
                size="small"
                @blur="qutaForm.quta_bag_prkg = helper.calcPrice(qutaForm.quta_bag_prkg, 4, 10000)"
                @change="emcdNumPriceChange(0)"
                @input="qutaForm.quta_bag_prkg = helper.keepEngNum4(qutaForm.quta_bag_prkg)"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.bag_prkg_price'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span
                >塑料袋金额:
                <el-popover content="金额=（长 * 宽 * 0.08) * 塑料袋公斤单价 / 装袋数" placement="top-start" trigger="hover" width="200">
                  <i slot="reference" class="el-icon-warning-outline"></i>
                </el-popover>
              </span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.bag_prkg_price" disabled size="small"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_emcd_num'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>电绣片数:</span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.quta_emcd_num" size="small" @change="emcdTotalPriceChnage(0)"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_emcd_hpru'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>电绣针数单价:</span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.quta_emcd_hpru" size="small" @change="emcdTotalPriceChnage(0)"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="vg_mb_8">
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.smpl_freight'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span>运费单价:</span>
            </el-col>
            <el-col :md="12">
              <el-input
                v-model="qutaForm.smpl_freight"
                size="small"
                @blur="qutaForm.smpl_freight = helper.calcPrice(qutaForm.smpl_freight, 4, 10000)"
                @change="freightPriceChange"
                @input="qutaForm.smpl_freight = helper.keepEngNum4(qutaForm.smpl_freight)"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.freight_price'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span
                >运费金额:
                <el-popover
                  content="金额==(纸箱)长x宽x高x运费系数（150）/装箱数（必须含运费才可计算）"
                  placement="top-start"
                  trigger="hover"
                  width="200"
                >
                  <i slot="reference" class="el-icon-warning-outline"></i>
                </el-popover>
              </span>
            </el-col>
            <el-col :md="12">
              <el-input v-model="qutaForm.freight_price" disabled size="small"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :md="6">
        <el-form-item
          :prop="'factoryList.' + formIndex + '.quta_emcd_price'"
          :rules="{ required: true, message: ' ', trigger: 'blur' }"
          label-width="0"
        >
          <el-row>
            <el-col :md="12" class="vd_lab_wid">
              <span
                >电绣金额:
                <el-popover content="金额=贴布价格+(片价数和针数价最大的那个）" placement="top-start" trigger="hover" width="200">
                  <i slot="reference" class="el-icon-warning-outline"></i>
                </el-popover>
              </span>
            </el-col>
            <el-col :md="12">
              <el-input
                v-model="qutaForm.quta_emcd_price"
                size="small"
                @change="getTotalPrice"
                @input="qutaForm.quta_emcd_price = helper.keepEngNum4(qutaForm.quta_emcd_price)"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-table
      :data="qutaForm.auxiliaryMaterialList"
      border
      class="vg_mt_16"
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" label="序号" type="index" width="70"></el-table-column>
      <el-table-column align="center" label="名称" prop="mtrl_name">
        <template slot="header">
          <span style="color: red">名称</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.auxiliaryMaterialList.' + scope.$index + '.mtrl_name'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input v-model="scope.row.mtrl_name" clearable maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="规格" min-width="140" prop="mtrl_spec">
        <template slot="header">
          <span style="color: red">规格</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.auxiliaryMaterialList.' + scope.$index + '.mtrl_spec'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input v-model="scope.row.mtrl_spec" clearable maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用量" min-width="140" prop="quta_mtrl_consume">
        <template slot="header">
          <span style="color: red">用量</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.auxiliaryMaterialList.' + scope.$index + '.quta_mtrl_consume'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="scope.row.quta_mtrl_consume"
              clearable
              maxlength="15"
              show-word-limit
              @change="mtrlConsumeChange(scope.$index)"
              @input="
                scope.row.quta_mtrl_consume =
                  scope.row.quta_mtrl_consume
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="耗损比率" min-width="140" prop="quta_mtrl_lossrate">
        <template slot="header">
          <span style="color: red">损耗比率</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.auxiliaryMaterialList.' + scope.$index + '.quta_mtrl_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="scope.row.quta_mtrl_lossrate"
              clearable
              maxlength="15"
              show-word-limit
              @change="mtrlLossrateChange(scope.$index)"
              @input="
                scope.row.quta_mtrl_lossrate =
                  scope.row.quta_mtrl_lossrate
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="单价" min-width="140" prop="mtrl_price">
        <template slot="header">
          <span style="color: red">单价</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.auxiliaryMaterialList.' + scope.$index + '.mtrl_price'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="scope.row.mtrl_price"
              clearable
              maxlength="15"
              show-word-limit
              @blur="scope.row.mtrl_price = helper.calcPrice(scope.row.mtrl_price, 4, 10000000000)"
              @change="getTotalPrice"
              @input="
                scope.row.mtrl_price =
                  scope.row.mtrl_price
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="right" label="金额" prop="mtrl_total_price" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="vd_price_toatl">
      <div class="vd_price">
        <h3><span>总计:</span></h3>
        <h2 class="vg_ml_8" style="color: #c70e0e">
          <span>{{ c_totalPrice }}</span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';

export default {
  name: 'QutaAuxiliary',
  props: {
    qutaForm: {
      type: Object,
      required: true
    },
    formIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dataList: [{}, {}, {}, {}, {}, {}],
      printingFilmPrice: 0,
      emcdTotalPrice: 0,
      totalPrice: 0,
      totalShow: true,
      multipleSelection: []
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  computed: {
    c_totalPrice() {
      if (this.totalPrice) return this.totalPrice;
      let sum2 = this.qutaForm.auxiliaryMaterialList.reduce((accumulator, currentItem) => {
        return accumulator.plus(new BigNumber(currentItem.mtrl_total_price || 0));
      }, new BigNumber(0));
      sum2 = sum2
        .plus(this.qutaForm.quta_emcd_price || 0)
        .plus(this.qutaForm.freight_price || 0)
        .plus(this.qutaForm.carton_price || 0)
        .plus(this.qutaForm.bag_prkg_price || 0);
      return sum2.toFixed(4);
    }
  },
  methods: {
    initData() {},
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 计算运费
    freightPriceChange(val) {
      let num1 = new BigNumber(1);
      num1 = num1
        .times(this.qutaForm.smpl_box_l)
        .div(100)
        .times(this.qutaForm.smpl_box_w)
        .div(100)
        .times(this.qutaForm.smpl_box_h)
        .div(100)
        .times(this.qutaForm.smpl_freight)
        .div(this.qutaForm.smpl_qpc)
        .toNumber();
      if (Number.isFinite(num1)) {
        this.qutaForm.freight_price = this.helper.haveFour(num1);
      } else {
        this.qutaForm.freight_price = '0.0000';
      }
      if (val === 0) {
        this.getTotalPrice();
      }
    },
    // 计算电绣金额
    emcdTotalPriceChnage(val) {
      let num1 = new BigNumber(1); //针数
      let num2 = new BigNumber(1); //片数
      let num3 = new BigNumber(1); //贴数
      let num4 = new BigNumber(0);
      if (Number(this.qutaForm.quta_emcd_hnum) % 1000 !== 0) {
        //电绣针数取整
        num1 = num1.times(this.qutaForm.quta_emcd_hnum).idiv(1000).plus(1);
      } else {
        num1 = num1.times(this.qutaForm.quta_emcd_hnum).div(1000);
      }
      num1 = num1.times(1000).times(this.qutaForm.quta_emcd_hpru).toNumber(); //电绣针数 * 电绣针数单价
      num2 = num2.times(this.qutaForm.quta_emcd_num).times(this.qutaForm.quta_emcd_pru).toNumber(); //电绣片数 * 电绣片数单价
      num3 = num3.times(this.qutaForm.quta_emcd_pnum).times(this.qutaForm.quta_emcd_ppru).toNumber(); //电绣贴数 * 电绣贴数单价
      if (num1 >= num2) {
        //如果 电绣针数 * 电绣针数单价 > 电绣片数 * 电绣片数单价 电绣金额则 = 电绣贴数 * 电绣贴数单价 + 电绣针数 * 电绣针数单价
        num4 = num4.plus(num3).plus(num1).toNumber();
      } else {
        //否则 = 电绣贴数 * 电绣贴数单价 + 电绣片数 * 电绣片数单价
        num4 = num4.plus(num3).plus(num2).toNumber();
      }
      if (Number.isFinite(num4)) {
        this.qutaForm.quta_emcd_price = this.helper.haveFour(num4);
      } else {
        this.qutaForm.quta_emcd_price = 0;
      }
      if (val === 0) {
        this.getTotalPrice();
      }
    },
    // 计算塑料袋金额
    emcdNumPriceChange(val) {
      if (Number(this.qutaForm.smpl_bag_l) > 0 && Number(this.qutaForm.smpl_bag_w) > 0) {
        let num1 = new BigNumber(1);
        num1 = num1.times(this.qutaForm.smpl_bag_l).div(100).times(this.qutaForm.smpl_bag_w).div(100).times(0.08);
        let num2 = new BigNumber(1);
        num2 = num2.times(num1).times(this.qutaForm.quta_bag_prkg).div(this.qutaForm.smpl_qpb).toNumber();
        if (Number.isFinite(num2)) {
          this.qutaForm.bag_prkg_price = this.helper.haveFour(num2);
        } else {
          this.qutaForm.bag_prkg_price = '0.0000';
        }
      } else {
        this.qutaForm.bag_prkg_price = '0.0000';
      }
      if (val === 0) {
        this.getTotalPrice();
      }
    },
    // 计算纸箱金额
    cartonPriceChange(val) {
      if (Number(this.qutaForm.smpl_box_l) > 0 && Number(this.qutaForm.smpl_box_w) > 0 && Number(this.qutaForm.smpl_box_h)) {
        let arr1 = [this.qutaForm.smpl_box_l, this.qutaForm.smpl_box_w, 8];
        let arr2 = [this.qutaForm.smpl_box_h, this.qutaForm.smpl_box_w, 4];
        let num1 = new BigNumber(0);
        num1 = BigNumber.sum(...arr1)
          .div(100)
          .toString();
        let num2 = new BigNumber(0);
        num2 = BigNumber.sum(...arr2)
          .div(100)
          .toString();
        let num3 = new BigNumber(1);
        num3 = num3.times(num1).times(num2).times(this.qutaForm.quta_ctn_prsm).div(this.qutaForm.smpl_qpc).toNumber();
        if (Number.isFinite(num3)) {
          this.qutaForm.carton_price = this.helper.haveFour(num3);
        } else {
          this.qutaForm.carton_price = '0.0000';
        }
      } else {
        this.qutaForm.carton_price = '0.0000';
      }
      if (val === 0) {
        this.getTotalPrice();
      }
    },
    getTotalPrice() {
      setTimeout(() => {
        this.totalShow = false;
        let num = new BigNumber(0);
        let num1 = new BigNumber(0);
        num = num
          .plus(this.printingFilmPrice)
          .plus(this.qutaForm.carton_price)
          .plus(this.qutaForm.bag_prkg_price)
          .plus(this.qutaForm.quta_emcd_price);
        if (this.qutaForm.smpl_frei_flag !== '0') {
          num = num.plus(this.qutaForm.freight_price);
        }
        for (let i = 0; i < this.qutaForm.auxiliaryMaterialList.length; i++) {
          if (
            Number(this.qutaForm.auxiliaryMaterialList[i].quta_mtrl_consume) > 0 &&
            Number(this.qutaForm.auxiliaryMaterialList[i].mtrl_price) > 0
          ) {
            let temp = new BigNumber(1);
            temp = temp
              .times(this.qutaForm.auxiliaryMaterialList[i].quta_mtrl_consume)
              .times(this.qutaForm.auxiliaryMaterialList[i].mtrl_price)
              .times(this.qutaForm.auxiliaryMaterialList[i].quta_mtrl_lossrate);
            num1 = num1.plus(temp);
            this.$set(this.qutaForm.auxiliaryMaterialList[i], 'mtrl_total_price', this.helper.haveFour(temp));
          } else {
            this.$set(this.qutaForm.auxiliaryMaterialList[i], 'mtrl_total_price', '0.0000');
          }
        }
        num = num.plus(num1).toNumber();
        this.totalPrice = this.helper.haveFour(num);
        this.$emit('getTotalPrice', this.totalPrice);
        this.totalShow = true;
      }, 500);
    },
    mtrlConsumeChange(index) {
      if (!this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_consume) {
        this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_consume = this.helper.calcPrice(1, 4, 10000000000);
      } else {
        this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_consume = this.helper.calcPrice(
          this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_consume,
          4,
          10000000000
        );
      }
      this.getTotalPrice();
    },
    mtrlLossrateChange(index) {
      if (!this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_lossrate) {
        this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_lossrate = this.helper.calcPrice(1, 4, 10000000000);
      } else {
        this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_lossrate = this.helper.calcPrice(
          this.qutaForm.auxiliaryMaterialList[index].quta_mtrl_lossrate,
          4,
          10000000000
        );
      }
      this.getTotalPrice();
    }
  }
};
</script>

<style lang="scss" scoped>
.vd_price_toatl {
  /* display: flex;
  justify-content: end; */
  padding: 10px 20px;
  text-align: right;
}

::v-deep .inpRig {
  > input {
    text-align: right;
  }
}

.vd_price {
  display: flex;
  justify-content: flex-end;
}

.vd_dis {
  display: flex;
}

.vd_lab_wid {
  text-align: right;
  padding-right: 10px;
}

.vd_lab_wid_o {
  width: 180px;
  text-align: right;
  padding-right: 10px;
}
</style>
